<template>
  <div class="lms-spotwind position-relative">
    <div v-if="errorMsg !== null" class="error"> {{ errorMsg }}</div>
    <div class="position-absolute" style="right: 20px; top: 65px; z-index: 100" v-if="isLoading"><img :alt="$t('loading')" :src="loadingUrl"> {{ $t('loading') }} ...</div>
    <div v-if="isDataLoaded">

      <form action="?" style="position: relative;">
        <div class="d-flex">

          <label class="w100 d-block tr" for="selectProduct">{{ $t('klima.products') }}:</label>

          <select class="w500 d-block mr-1" id="selectProduct" v-model="selectedProduct">
            <option v-for="product in listOfProducts" :value="product.id">{{ product.name[lang] }}</option>
          </select>

          <label class="w75 d-block tr" for="selectDate">{{ $t('klima.date') }}:</label>
          <date-picker
              v-model="dt"
              format="DD.MM.YYYY"
              valueType="timestamp"
              :editable=false
              :clearable=false
              :disabled-date="disabledDate"
          >
          </date-picker>

          <button type="button" :title="$t('prev')"  class="button button-icon-only d-block w50" @click="prevDay()" :disabled="prevDisabled"><i class="icon-navigate_before"></i></button>
          <button type="button" :title="$t('next')"  class="button button-icon-only d-block w50" @click="nextDay()" :disabled="nextDisabled"><i class="icon-navigate_next"></i></button>

          <div class="d-flex ml-3" style="align-items: baseline">
            <input type="checkbox" v-model="showOkresy" name="okresy" value="1" id="okresy" class="d-block">
            <label for="okresy" class="d-block w175">Zobraziť okresné mestá</label>
          </div>

        </div>
        <div class="d-flex mt-2" v-if="isForecastProduct">
          <label class="w100 d-block tr pt-2" for="slider-forecast">{{ $t('klima.predpoved') }}:</label>
          <input type="range"  id="slider-forecast" v-model="currentForecastIndex" class="slider w500" min="0" :max="maxForecastItems" step="1">
          <div class="d-block pl-4 pt-3"><strong>{{ forecastText }}</strong></div>

        </div>

        <div class="clearfix"></div>
      </form>

      <div class="text-center">
        <h2 class="m-0">{{ selectedProductFull.name[lang] }}
        <template v-if="selectedProductFull.unit">
          [{{ selectedProductFull.unit }}]
        </template>
        </h2>
      </div>

      <template v-if="productNotFound">
        <div class="error">Pre vybraný produkt a dátum neboli nájdené mapové súbory</div>

      </template>
      <template v-else>
        <template v-if="isForecastProduct">

          <template v-if="currentForecastIndex == 0">
            <ImgPZCTComponent
                :show-okresy="showOkresy"
                :colors="colorsForProduct"
                :selected-product-data="selectedProductByDate"
                :current-image="getForecastFile(0, '')"
                :districts="productsData.districts"
            >


            </ImgPZCTComponent>
          </template>
          <template v-else>
            <template v-for="type in selectedProductFull.show_forecast_maps">
              <div class="text-center"><h3 class="m-0">{{ typeTrans(type) }}</h3></div>
              <ImgPZCTComponent
                  :show-okresy="showOkresy"
                  :colors="colorsForProduct"
                  :selected-product-data="selectedProductByDate"
                  :current-image="getForecastFile(currentForecastIndex, type)"
                  :districts="productsData.districts"
              >
              </ImgPZCTComponent>
            </template>
          </template>

        </template>
        <template v-else>
          <ImgPZCTComponent
              :show-okresy="showOkresy"
              :colors="colorsForProduct"
              :selected-product-data="selectedProductByDate"
              :current-image="currentImage"
              :districts="productsData.districts"
          ></ImgPZCTComponent>

        </template>
      </template>

    </div>

    <image-preloader :srcs="listOfImages" v-on:loaded="imageLoaded"></image-preloader>

  </div>
</template>

<script>

import SHMUconf from '../../shmu_conf';
import Axios from "axios";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import '../../datepicker-lang-sk';
import ImgPZCTComponent from "./ImgPZCTComponent.vue";
import ImagePreloader from "../../components/imagePreloader.vue";

export default {
  components: {
    ImgPZCTComponent,
    DatePicker,
    ImagePreloader
  },
  name: 'KlimaProductsComponent',
  props: {
    msg: String
  },
  data() {
    return {
      selectedGroup: 'dkm',
      productsData: {},
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      isError: false,
      errorMsg: null,
      isDataLoaded: false,
      isLoading: false,
      selectedProduct: null,
      prevDisabled: false,
      nextDisabled: false,
      dt: null,
      productNotFound: false,
      currentForecastIndex:0,
      currentProgress: 0,
      currentIndex: -1,
      showOkresy: true

    }
  },
  watch: {
    dt(v) {
      this.handleArrowButtons(v);
    },
    selectedProduct(v) {
      const self = this;
      this.$nextTick(function () {
        if (self.dt === null) {
          self.dt = self.maxDt
        }
      });
      this.currentForecastIndex = 0;

    },
    showOkresy(v) {
      this.$ls.set('klima-okresy', v, 365 * 24 * 60 * 60 * 1000);
    },

  },
  mounted() {
    if (typeof window.klimaGroup !== 'undefined') {
      this.selectedGroup = window.klimaGroup;
    }

    if (this.$ls.get('klima-okresy') === false) {
      this.showOkresy = false;
    } else {
      this.showOkresy = true;
    }

    this.getData();
  },
  computed: {
    lang() {
      return window.wn_lang;
    },
    minDt() {
      let minDt = this.$moment.unix() * 1000;
      if (this.productsData.avail_dates.min_date) {
        minDt = this.$moment(this.productsData.avail_dates.min_date + ' 00:00:00').unix() * 1000
      }
      return minDt;
    },
    maxDt() {
      let maxDt = this.$moment.unix() * 1000;
      if (this.productsData.avail_dates.max_date) {
        maxDt = this.$moment(this.productsData.avail_dates.max_date + ' 00:00:00').unix() * 1000
      }
      return maxDt;
    },
    listOfProducts() {
      if (this.productsData) {
        let res = this.productsData.products_list.find(item => item.group === this.selectedGroup);
        if (res) {
          return res.products.sort((a,b) => (parseInt(a.order) > parseInt(b.order)) ? 1 : ((parseInt(b.order) > parseInt(a.order)) ? -1 : 0));
        }
      }
      return [];
    },
    selectedProductFull() {
      return this.listOfProducts.find(item => item.id === this.selectedProduct);
    },
    selectedProductByDate() {
      const sDate = this.selectedDate;
      const sProduct = this.selectedProduct;
      if (sDate && sProduct) {
        return this.productsData.data.find((item) => {
          return item.for_date === sDate && item.produkt === sProduct;
        });
      }
      return null;
    },
    isForecastProduct() {
      return this.selectedProductFull?.has_forecast;
    },
    selectedDate() {
      if (this.dt) {
        return this.$moment.unix(this.dt / 1000).format('YYYY-MM-DD');
      }
      return null;
    },
    colorsForProduct() {
      return this.productsData.colors[this.selectedProduct];
    },
    currentImage() {

      if (this.files.length > 0) {
        this.isImageLoading = true;
        let product = this.selectedProductByDate;
        if (SHMUconf.IS_DEVEL) {
           return this.productsData.base_dir.replace('www', 'w5') + product.dir_date + '/' + this.files[0]; // TODO: remove w5 replacer
        }
        return this.productsData.base_dir + product.dir_date + '/' + this.files[0];
      }
      return SHMUconf.SITE_BASE_URL + 'img/blank1px.gif';
    },
    files() {

        let product = this.selectedProductByDate;
        if (product) {
          this.productNotFound = false;
          return product.subory;
        } else {
          this.productNotFound = true;
        }

      return []
    },
    listOfImages() {
      let arr = [];
      if (this.files.length > 0) {

        let product = this.selectedProductByDate;

        this.files.forEach((item) => {
          let f = this.productsData.base_dir + product.dir_date + '/' + item;
          if (SHMUconf.IS_DEVEL) {
            f = this.productsData.base_dir.replace('www', 'w5') + product.dir_date + '/' + item;
          }
          arr.push(f);
        });
      }
      return arr;
    },
    forecastText() {
      let str = '';
      if (parseInt(this.currentForecastIndex) === 0) {
        str = 'Analýza z: ' + this.$moment(this.fileDate).format('DD.MM.YYYY');
      } else {
        str = 'Predpoveď na: ' + this.$moment(this.fileDate).add(this.currentForecastIndex, 'd').format('DD.MM.YYYY');
      }
      return str;
    },
    fileDate() {
      if (this.files.length > 0) {
        let file = this.files[0];
        let res = file.match(/_([0-9]{4}-[0-9]{2}-[0-9]{2})_/im);
        if (res.length) {
          return res[1];
        }
      }
      return null;
    },
    maxForecastItems() {
      const files = this.files;
      let max_d = 0;
      files.forEach((item) => {
        let res = item.match(/\_d([\d+])\_|\.]/im);
        if (res) {
          if (res["1"] && parseInt(res["1"]) > max_d) {
            max_d = parseInt(res["1"])
          }
        }
      });
      return max_d;

    }


  },
  methods: {
    getData() {
      const self = this;

      self.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'klima/getklimaproducts', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.productsData = response.data;
          // const temp = this.productsList; // len populate
          if (self.productsData && self.productsData.products_list.length > 0) {
            self.selectedProduct = self.listOfProducts[0].id;
          }

          self.isDataLoaded = true;
          this.isError = false;
          this.errorMsg = null;

        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            this.errorMsg = response.data.error[0].text;
          } else {
            this.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }
        }
        this.isLoading = false;
      }).catch((error) => {
        console.log(error);
        this.isError = true;
        this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        this.isLoading = false;
      });

    },
    prevDay() {
      this.dt = this.$moment.unix(this.dt / 1000).add(-1, 'd').unix() * 1000;
    },
    nextDay() {
      this.dt = this.$moment.unix(this.dt / 1000).add(+1, 'd').unix() * 1000;
    },
    handleArrowButtons(dt) {
      let cur_base = this.$moment.unix(dt / 1000).format('YYYY-MM-DD 00:00');
      let cur_ts = this.$moment(cur_base).unix() * 1000;
      this.prevDisabled = cur_ts <= this.minDt;
      this.nextDisabled = cur_ts >= this.maxDt;
    },
    disabledDate(date) {
      if (this.$moment(date).unix() * 1000 < this.minDt) return true;
      if (this.$moment(date).unix() * 1000 > this.maxDt) return true;
      return false
    },
    getForecastFile(index, type) {
      let str = this.selectedProduct + '_' + this.fileDate + '_';
      if (parseInt(index) === 0) str += 'd0.png';
      else {
        str += 'predpoved_d'+index+'_'+type+'.png';
      }
      let product = this.selectedProductByDate;

      if (SHMUconf.IS_DEVEL) {
        return this.productsData.base_dir.replace('www', 'w5') + product.dir_date + '/' + str;
      }
      return this.productsData.base_dir + product.dir_date + '/' + str;
    },
    imageLoaded(e) {
      this.currentProgress = Math.round(e.progress);
      this.currentIndex = e.index;
      if (this.currentProgress < 100) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    },
    typeTrans(type) {
      if (type === 'mean') {
        return 'Priemerná hodnota ansámbla';
      } else if (type === 'perc10') {
        return '10. percentil ansámbla'
      } else if (type === 'perc90') {
        return '90. percentil ansámbla'
      }
    }


  }
}
</script>

<style lang="scss">
.images-wrapper {
  img {
    width: 100%;
    max-height: 100%;

    &.hidden {
      display: none;
    }


    &:hover {
      cursor: zoom-in;
    }
  }
}


.mx-table {
  border: 1px solid #aeb0b5 !important;
  border-collapse: collapse;
}

.mx-table td {
  border: 1px solid #aeb0b5 !important;
}
.mx-table-date th {
  border: 0px !important;
}
.mx-datepicker-main {
  color: #000;
}

.mx-calendar-content .cell.active {
  background-color: #1b365d;
}

.mx-table-date .today {
  color: #cd2026 !important;
  background-color: transparent !important;

}

.mx-table-date .today {

  &.active {
    color: #fff !important;
    background-color: #cd2026 !important;
  }

}

.mx-calendar-content .cell:hover {
  color: #fff;
  background-color: #205493;
}


.mx-datepicker,
.mx-input { width: 120px !important;
  padding: unset;
  margin: unset;
  line-height: 1.3;
  height: unset !important;
  box-shadow: unset!important;
}
.mx-btn {
  color: #000;
  &:hover {
    color: #cd2026;
  }
}

.tooltipx {
  position: absolute;
  background-color: rgba(0,0,0,0.7);
  color: white;
  border: none;
  border-radius: 3px;
  padding: 3px 5px;
  top: -500px;
  left: -500px;
  text-align: center;
  z-index: 100;
  /*
  width: 60px;
  height: 23px;

   */
  line-height: 18px;
  font-size:0.8rem;
  display: none;
}




</style>
